export default {
  order: 3,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'AG_BIOMASS',
    order: 3,
    type: 'remoteDataLayer',
    uuid: '04526d47-f3f5-4f76-a939-e5f7861fd085',
    groupId: 'GROUP_LC',
  },
  layer: {
    id: 'AG_BIOMASS',
    metadata: {
      metadata: null,
      legendConfig: {
        type: 'gradient',
        name: {
          en: 'Aboveground Live Woody Biomass Density',
          fr: 'Densité de la biomasse ligneuse vivante aérienne',
          es: 'Densidad de la biomasa leñosa viva en superficie',
          pt: 'Densidade de vegetal lenhoso vivo acima do solo',
          id: 'Kerapatan biomassa vegetasi berkayu di atas permukaan tanah',
          zh: '地上活木生物量质密度',
          ka: 'მიწისზედა ცოცხალი ტყის ბიომასის სიხშირე',
        },
        items: [
          {
            name: {
              zh: '500 Mg Ha -1',
              pt: '500 Mg Ha -1',
              ka: '500 Mg Ha -1',
              id: '500 Mg Ha -1',
              fr: '500 Mg Ha -1',
              es: '500 Mg Ha -1',
              en: '500 Mg Ha -1',
            },
            color: '#306466',
          },
          {
            name: {
              zh: '250 Mg Ha -1',
              pt: '250 Mg Ha -1',
              ka: '250 Mg Ha -1',
              id: '250 Mg Ha -1',
              fr: '250 Mg Ha -1',
              es: '250 Mg Ha -1',
              en: '250 Mg Ha -1',
            },
            color: '#cccc66',
          },
          {
            name: {
              zh: '0',
              pt: '0',
              ka: '0',
              id: '0',
              fr: '0',
              es: '0',
              en: '0',
            },
            color: '#6e462d',
          },
        ],
      },
      interactionConfig: {},
    },
    type: 'image',
    url: 'https://gis-gfw.wri.org/arcgis/rest/services/image_services/whrc_carbon_tcd/ImageServer',
    technicalName: 'aboveground_biomass',
    label: {
      en: 'Aboveground Live Woody Biomass Density',
      fr: 'Densité de la biomasse ligneuse vivante aérienne',
      es: 'Densidad de la biomasa leñosa viva en superficie',
      pt: 'Densidade de biomassa viva acima do solo',
      id: 'Kerapatan biomassa vegetasi berkayu di atas permukaan tanah',
      zh: '地上活木生物量质密度',
      ka: 'მიწისზედა ცოცხალი ტყის ბიომასის სიხშირე',
    },
    sublabel: {
      en: '(30m, tropics, Zarin/WHRC)',
      fr: '(30 m, tropiques, Zarin/WHRC)',
      es: '(30 m, trópicos, Zarin/WHRC)',
      pt: '(30 m, trópicos, Zarin/WHRC)',
      id: '(30m, tropis, Zarin/WHRC)',
      zh: '(30m，热带地区，Zarin/WHRC）',
      ka: '(30 მ, ტროპიკები, Zarin/WHRC)',
    },
  },
  isMetadataError: false,
  isError: false,
};
